import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useLanguage } from '@/i18n/LanguageContext';

export const StudentFormDialog = ({ open, onOpenChange, editingStudent, formData, setFormData, classes, onSubmit }) => {
  const { t } = useLanguage();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border">
        <DialogHeader>
          <DialogTitle>{editingStudent ? t('students.editStudent') : t('students.createStudent')}</DialogTitle>
          <DialogDescription className="sr-only">
            {t('students.description')}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label>{t('students.studentName')}</Label>
            <Input
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder={t('students.studentNamePlaceholder')}
              required
              className="bg-secondary border-border"
              data-testid="student-name-input"
            />
          </div>
          <div className="space-y-2">
            <Label>{t('students.selectClass')}</Label>
            <Select value={formData.class_id} onValueChange={(v) => setFormData({ ...formData, class_id: v })}>
              <SelectTrigger className="bg-secondary border-border" data-testid="student-class-select">
                <SelectValue placeholder={t('students.selectClass')} />
              </SelectTrigger>
              <SelectContent className="bg-card border-border">
                {classes.map((cls) => (
                  <SelectItem key={cls.class_id} value={cls.class_id}>
                    {cls.name} ({cls.year})
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <Button type="submit" className="w-full bg-primary hover:bg-primary/90" data-testid="save-student-btn">
            {editingStudent ? t('common.update') : t('common.create')}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
